export default "__VITE_ASSET__DdVfesqO__"